
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/procurement-service",
      function () {
        return require("private-next-pages/procurement-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/procurement-service"])
      });
    }
  